export default __webpack_public_path__ + "static/media/18.90fbca25.png";